module.exports = __webpack_public_path__ + "static/assets/31233f7f72ad06fc2244f4b19cb9eafe.png";